import { useRedux } from 'hooks/index';
import {
    lectureAdminUpsert,
    lectureAdminViewAll,
    lectureAdminViewAllShort,
    lectureAdminViewDetails,
    lectureUserReset,
    lectureUserViewDetails,
    lectureUserViewRecap,
} from '../../redux/theory/lecture/actions';
import { LectureNew } from '../../types/theory/lecture';

export default function useLecture() {
    const { dispatch, appSelector } = useRedux();

    const { loading, apiUpsertSuccess, adminAllLecturesShort, adminAllLectures, adminLectureDetails, userLectureRecap, userLectureDetails, error } = appSelector((state) => ({
        loading: state.Lecture.loading,
        apiUpsertSuccess: state.Lecture.apiUpsertSuccess,
        adminAllLecturesShort: state.Lecture.adminAllLecturesShort,
        adminAllLectures: state.Lecture.adminAllLectures,
        adminLectureDetails: state.Lecture.adminLectureDetails,
        userLectureDetails: state.Lecture.userLectureDetails,
        userLectureRecap: state.Lecture.userLectureRecap,
        error: state.Lecture.error,
    }));

    const adminLoadAllLectures = (page: number, size: number) => {
        dispatch(lectureAdminViewAll(page, size));
    };

    const adminLoadLectureDetails = (id: string) => {
        dispatch(lectureAdminViewDetails(id));
    };

    const adminLoadAllLecturesShort = () => {
        dispatch(lectureAdminViewAllShort());
    };

    const adminUpsertLecture = (data: LectureNew) => {
        dispatch(lectureAdminUpsert(data));
    };

    const userLoadLectureDetails = (slug: string) => {
        dispatch(lectureUserViewDetails(slug));
    };

    const userLoadLectureRecap = (slug: string) => {
        dispatch(lectureUserViewRecap(slug));
    };

    const userResetLectureDetails = () => {
        dispatch(lectureUserReset());
    };

    return {
        adminAllLectures,
        adminAllLecturesShort,
        adminLectureDetails,
        adminLoadAllLectures,
        adminLoadAllLecturesShort,
        adminLoadLectureDetails,
        adminUpsertLecture,
        userLoadLectureDetails,
        userLoadLectureRecap,
        userResetLectureDetails,
        apiUpsertSuccess,
        userLectureDetails,
        userLectureRecap,
        error,
        loading,
    };
}
